import * as React from 'react';
import { Box, ButtonBase, IconButton, Typography, DialogTitle, Dialog } from "@mui/material";
import FormBox from './building_blocks/FormBox';
import { useContext } from 'react';
import SnackbarContext from '../contexts/SnackbarContext';
import cardsPathTo from '../utils/Api/cardsPathTo';
import { useEffect } from 'react';
import visa from '../images/visa_card.png';
import master from '../images/master_card.png';
import TrashIcon from '../images/trash.png';

const PaymentMethodsDialog = (props) => {
  const { onClose, paymentMethods, setPaymentMethods, open, setOpenNewCardDialog, selectedPaymentIndex } = props;
  const { openSnackbar } = useContext(SnackbarContext);

  const handleDelete = (id, index) => {
    if(window.confirm("Deseja remover este cartão?")) {
      cardsPathTo.delete(id).then(() => {
        setPaymentMethods([...paymentMethods.slice(0, index), ...paymentMethods.slice(index + 1)]);
        openSnackbar("Cartão removido com sucesso!", "success");
      });
    }
  };

  const selectPaymentMethod = (index) => {
    handleClose(paymentMethods[index]);
  };

  const handleClose = (paymentMethod = null) => {
    if (paymentMethod === null) {
      onClose(paymentMethods[selectedPaymentIndex]);
    } else {
      onClose(paymentMethod);
    }
  };

  return (
    <Dialog open={open} onClose={() => handleClose()} fullWidth={true} maxWidth="md">
      <DialogTitle><b>Formas de pagamento</b></DialogTitle>
        {/* <Typography sx={{ marginTop: '18px' }} color="primary" variant="h5">
        </Typography> */}
    
      <Box>
        {paymentMethods.map((paymentMethod, index) => (
          <FormBox display="flex" flexDirection="column" key={index}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Box>
                {paymentMethod.card.brand === 'visa' ? <img src={visa} style={{ width: '40px' }} /> : <img src={master} style={{ width: '40px' }} />}
              </Box>
              <Box flexGrow={1} ml={2} textAlign="left">
                <Typography sx={{ fontSize: '14px', textTransform: 'capitalize' }}>{paymentMethod.card.brand} &#9679; {paymentMethod.card.funding === 'debit' ? 'Debito' : 'Crédito'}</Typography>
                <Typography sx={{ fontSize: '14px' }} color="gray">**** {paymentMethod.card.last4}</Typography>
              </Box>
              <Box flexGrow={1} ml={2} textAlign="right">
                <ButtonBase onClick={() => selectPaymentMethod(index)}>
                  <Typography fontSize={14} color="orange">Selecionar</Typography>
                </ButtonBase>

                <IconButton onClick={() => handleDelete(paymentMethod.id, index)}>
                  <img src={TrashIcon} style={{ width: '20px' }} />
                </IconButton>
              </Box>
            </Box>
          </FormBox>
        ))}
        <FormBox display="flex" flexDirection="column" >
          <ButtonBase onClick={() => setOpenNewCardDialog(true) }>Adicionar novo cartão</ButtonBase>
        </FormBox>
        {/* <Typography color="primary">
          <ButtonBase onClick={() => setOpenNewCardDialog(true) }>
            Adicionar novo cartão
          </ButtonBase>
        </Typography> */}
      </Box>
    </Dialog>
  );
};

export default PaymentMethodsDialog;

